import { ValueOf } from 'type-fest';
import { spacing } from '../../../style';
import { sizes as iconSizes } from '../../icon/style';
import { sizes as inputSizes } from '../style';

export type InputSizesType = '2xxl' | 'xxl' | 'xl' | 'lg' | 'auto';
type InputSizeProperties = {
  fontSize: string;
  height: string;
  iconSize: keyof typeof iconSizes;
  padding?: string;
  componentClass: 'textarea' | 'input';
  borderRadius?: ValueOf<typeof spacing>;
};

export const TextareaAutogrowSizes: Record<InputSizesType, InputSizeProperties> = {
  ...inputSizes,
  xl: {
    fontSize: '1rem',
    height: '54px',
    iconSize: 'xl',
    componentClass: 'input',
    borderRadius: spacing.lg,
  },
};
